// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { STEP_NAME_TO_PRIORITY } from '@seedplanner/shared-utils';

export function sortTasksByName(a: string, b: string) {
  const aPriority = getPriorityFromName(a);
  const bPriority = getPriorityFromName(b);
  return aPriority > bPriority ? -1 : aPriority < bPriority ? 1 : 0;
}

function getPriorityFromName(name: string) {
  return STEP_NAME_TO_PRIORITY.get(name) ?? -1;
}

interface Task {
  readonly task_name: string;
  readonly task_time: number;
  readonly crop?: {
    readonly crop_name: string;
  } | null;
}
export function compareTasks(taskA: Task, taskB: Task) {
  const aTime = taskA.task_time;
  const bTime = taskB.task_time;
  const aName = taskA.task_name;
  const bName = taskB.task_name;
  const aCropName = taskA.crop?.crop_name;
  const bCropName = taskB.crop?.crop_name;

  // First compare by time
  if (aTime < bTime) {
    return -1;
  }
  if (aTime > bTime) {
    return 1;
  }

  // If names are equal, compare by crop name
  if (aName === bName && aCropName !== undefined && bCropName !== undefined) {
    return aCropName.localeCompare(bCropName);
  }

  return sortTasksByName(aName, bName);
}
